import ApiBase from './ApiBase';
import LogApi from './LogApi';
import { getIcError } from '../../core/providers/utils';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

/**
 * Mail API
 */
class MailApi extends ApiBase {
  /**
   * send Email To List
   * @param data
   */
  async sendMailToList(data) {
    const trackingId = uuidv4();

    LogApi.sendClientlogs(
      LogApi.createTrackingObject(
        trackingId,
        null,
        `resourceUploadId: ${data?.resourceUploadId}`,
        null,
        null,
        `POST v1/mail/sendmailtolist`,
        `Delivery Tab Send Email API call`
      )
    ).catch(err => {
      console.error('Server error: ' + getIcError(err));
    });

    // Get headers for form-data split method
    const headers = this.getHeaders();
    headers['TRACKING-REQUEST-ID'] = trackingId;

    const request = {
      url: `${this.API_URL}/mail/sendmailtolist`,
      method: 'POST',
      headers: headers,
      data: data
    };

    const response = await axios.request(request);
    return response.data;
  }
}
export default new MailApi();
